;(function () {

"use strict";

var FormView = require('../views/form');

var SettingsFormView = FormView.extend({
  save: function (e) {
    console.log('saving');
    FormView.prototype.save.call(this, e);

    ShopifyApp.Bar.loadingOn();
    $.post('/settings', this.$el.serialize(), _.bind(this.onSave, this));
  },
  onSave: function (data) {
    console.log(data);
    console.log('save completed');

    ShopifyApp.Bar.loadingOff();

    if (data.status === 'success') {
      ShopifyApp.flashNotice(data.msg);
    } else {
      ShopifyApp.Modal.alert({
        title: 'Saving Settings Failed',
        message: data.err
      });
    }
  }
});

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('setting page view init');
    new SettingsFormView({el: this.$el.find('form').first() });
  },
  events: {
    'change .use-aws input[type="radio"]': function (e) {
      var $this = $(e.currentTarget);
      var val = $this.val();
      if (val === "yes") {
        this.$el.find('input.aws').removeAttr('disabled');
      } else {
        this.$el.find('input.aws').attr('disabled', true);
      }
    },
    'change .use-api input[type="radio"]': function (e) {
      var $this = $(e.currentTarget);
      var val = $this.val();
      if (val === "yes") {
        this.$el.find('input.api-whitelist').removeAttr('disabled');
      } else {
        this.$el.find('input.api-whitelist').attr('disabled', true);
      }
    }
  }
});

module.exports = PageView;


}());